import { render, staticRenderFns } from "./add-edit-client-member.vue?vue&type=template&id=6f5517b4&scoped=true&"
import script from "./add-edit-client-member.vue?vue&type=script&lang=js&"
export * from "./add-edit-client-member.vue?vue&type=script&lang=js&"
import style0 from "./add-edit-client-member.vue?vue&type=style&index=0&id=6f5517b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5517b4",
  null
  
)

component.options.__file = "add-edit-client-member.vue"
export default component.exports